import React, { createContext, useState } from 'react';
import MODES from '../types/Modes';
export var SystemContext = createContext({
    mode: MODES.BROWSING,
    setMode: function (mode) { return null; },
    selecting: false,
    setSelecting: function (selecting) { return null; },
    onSelect: function () { return null; },
    onFocus: function () { return null; }
});
var SystemProvider = function (_a) {
    var onSelect = _a.onSelect, onFocus = _a.onFocus, tool = _a.tool, children = _a.children;
    var _b = useState(MODES.BROWSING), mode = _b[0], setMode = _b[1];
    var _c = useState(!tool), selecting = _c[0], setSelecting = _c[1];
    return (React.createElement(SystemContext.Provider, { value: {
            mode: mode,
            setMode: setMode,
            selecting: selecting,
            setSelecting: setSelecting,
            onSelect: onSelect,
            onFocus: onFocus
        } }, children));
};
export default SystemProvider;
